import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { DisplayPriorityCampaign, Placement } from 'modules/placements/types';
import { EmbeddedCampaignWithContent } from '../hooks/useFetchEmbeddedTemplatesByCampaigns';

type DisplayPriorityContextState = {
  campaignsByPlacement: DisplayPriorityCampaign[];
  campaignPlacement: Placement | undefined;
  campaignDisplayPriorityOrder: DisplayPriorityCampaign[];
  setCampaignDisplayPriorityOrder: (updated: DisplayPriorityCampaign[]) => void;
  setShowCampaign: (index: number) => void;
  isDirty: boolean;
  isCampaignEditorView: boolean;
  reset: () => void;
  saveDisplayPriority: () => void;
  campaignsWithContent: EmbeddedCampaignWithContent[];
  isLoadingCampaignsWithContent: boolean;
  isLoadingCampaignsForPlacement: boolean;
};

export const DEFAULT_DISPLAY_PRIORITY_CONTEXT_STATE: DisplayPriorityContextState = {
  campaignsByPlacement: [],
  campaignPlacement: undefined,
  campaignDisplayPriorityOrder: [],
  setCampaignDisplayPriorityOrder: noop,
  setShowCampaign: noop,
  isDirty: false,
  isCampaignEditorView: false,
  reset: noop,
  saveDisplayPriority: noop,
  campaignsWithContent: [],
  isLoadingCampaignsWithContent: false,
  isLoadingCampaignsForPlacement: false,
};

export const DisplayPriorityContext = createContext<DisplayPriorityContextState>(
  DEFAULT_DISPLAY_PRIORITY_CONTEXT_STATE,
);

export const useDisplayPriorityContext = () => useContext(DisplayPriorityContext);
